import { api } from './client';

export interface NonInsurablePeriodDto {
  id: number;
  workerId: number;
  workerName: string;
  contractSerial: string;
  contractNumber: number;
  dateFrom: string;
  dateTo: string;
  reasonCode: string;
  reasonText: string;
  basis: string | null;
  status: string;
  source: number;
}

export const NON_INSURABLE_REASONS: { code: string; label: string }[] = [
  { code: '01', label: 'Nemokamos atostogos' },
  { code: '02', label: 'Kvalifikacijos tobulinimas' },
  { code: '03', label: 'Kūrybinės atostogos' },
  { code: '04', label: 'Neapmokamos mokymosi atostogos' },
  { code: '05', label: 'Kitas teisėtas neatvykimas' },
  { code: '06', label: 'Atostogos vaikui prižiūrėti' },
  { code: '07', label: 'Nedarbingumas' },
  { code: '08', label: 'Nušalinimas nuo darbo' },
  { code: '09', label: 'Pravaikštos' },
  { code: '10', label: 'Karo prievolė, tarnyba ar pratybos' },
  { code: '99', label: 'Kiti neatvykimai' },
];

export const nonInsurableApi = {
  list: (from?: string, to?: string) =>
    api.get<NonInsurablePeriodDto[]>('/payroll/non-insurable-periods', { from, to }),

  save: (body: { id?: number | null; workerId: number; contractNumber: number; contractSerial?: string | null; dateFrom: string; dateTo: string; reasonCode: string; basis?: string | null }) =>
    api.post<number>('/payroll/non-insurable-periods', body),

  setStatus: (id: number, action: 'approve' | 'declare' | 'cancel') =>
    api.post<void>(`/payroll/non-insurable-periods/${id}/${action}`, {}),

  delete: (id: number) => api.delete<void>(`/payroll/non-insurable-periods/${id}`),

  backfill: (from: string, to: string) =>
    api.post<number>(`/payroll/non-insurable-periods/backfill?from=${from}&to=${to}`, {}),
};
